import { render, staticRenderFns } from "./questionJigsaw.vue?vue&type=template&id=4bba133d&scoped=true&"
import script from "./questionJigsaw.vue?vue&type=script&lang=js&"
export * from "./questionJigsaw.vue?vue&type=script&lang=js&"
import style0 from "./questionJigsaw.vue?vue&type=style&index=0&id=4bba133d&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bba133d",
  null
  
)

export default component.exports